import React from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { styled } from '@mui/system';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#7b1fa2',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#f1e1f5',
  },
  '& .MuiSwitch-switchBase': {
    color: '#d3d3d3',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#e0e0e0',
  },
}));

const CategorySwitches = ({ categories, activeCategories, onCategoryChange }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{ width: '100%', height: '100%' }}
    >
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          padding: '14px 16px 10px',
          borderBottom: '1px solid #f1e1f5',
          flexShrink: 0,
          backgroundColor: '#ffffff',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Libre Baskerville !important',
            color: '#7b1fa2',
            fontSize: '1.2rem',
            lineHeight: 1.3,
          }}
        >
          Visualizing Organic Wine Additives
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif !important',
            color: 'grey',
            fontSize: '0.7rem',
            marginTop: '4px',
          }}
        >
          source:{' '}
          <a
            href="https://www.perdomini-ioc.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'grey', textDecoration: 'underline' }}
          >
            perdomini-ioc.com
          </a>
          {' '} | built by{' '}
          <a
            href="https://www.fincuva.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'grey', textDecoration: 'underline' }}
          >
            fincuva
          </a>
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingTop: '6px',
          paddingBottom: '10px',
          '&::-webkit-scrollbar': { width: '6px' },
          '&::-webkit-scrollbar-thumb': { backgroundColor: '#f0e6f2', borderRadius: '6px' },
          '&::-webkit-scrollbar-track': { backgroundColor: '#ffffff' },
        }}
      >
        {Object.keys(categories).map(category => (
          <Box
            key={category}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              backgroundColor: '#ffffff',
              color: '#333',
              margin: '1px 5px',
              textTransform: 'none',
              width: '90%',
              maxWidth: '260px',
              height: '32px',
              borderRadius: '12px',
              padding: '0 8px 0 14px',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '0.8rem',
                lineHeight: '1.1',
              }}
            >
              {category}
            </Typography>
            <CustomSwitch
              size="small"
              checked={activeCategories.includes(category)}
              onChange={() => onCategoryChange(category)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CategorySwitches;
